// Pricing Page Entry Point
import '../../js/config.js';
import '../../js/initSideNav.js';
import '../../pricing.js';
